import { ViewEventTarget } from '../../event';
import { IGraphicView } from './graphic.view';


export abstract class DefaultGraphicView extends ViewEventTarget implements IGraphicView {
  $element: JQuery;

  abstract init(...params: Array<any>);

  /**
   * 第一次需要同时提供config和data，方可View更新
   * @param config
   * @param data
   */
  update(config: any, data: any) {
  }

  updateConfig(config: any) {

  }

  /**
   * 更新数据  建议任何图表都要能做到 数据和配置可以独立更新
   * 更新数据时往往需要config信息，对于图表可以有默认的config信息。也可以在没有config的情况下只是缓存data，不做更新数据操作
   * @param data
   */
  updateData(data: any) {
  }

  /**
   * 一般主题切换从上而下
   * 切换主题
   * 切换主题的前提  view 需要处于可用状态
   * 切换主题要保证 config和data继续正常显示，因此graphicView有必要缓存config和data的信息
   * @param theme
   */
  updateTheme(theme: string) {
  }

  /**
   * 内容自适应区域大小
   * 一般在设计模式下使用
   * resize时可能使用到config和data重新绘制视图，因此需要缓存config和data
   */
  resize() {
  }

  /**
   * 编辑单个图表时，进入激活状态、只有在设计模式下使用
   * 可能需要使用到config和data，甚至需要将修改后的config回传
   */
  activate() {
  }

  /**
   * 退出激活状态
   */
  deactivate() {
  }
}
